import { useTranslation } from "react-i18next";
import { DATE_MASKED } from "./utils";
import moment from "moment";

const env = process.env.NODE_ENV || "development";

//chạy test nội bộ
export const constHostAddressConfig = {
   // WSHostAddress: env === "production" ? "ws://192.168.2.162:5000/ws" : "wss://api.apsi.vn:5003/ws",
   // ApiTVSIAddress: env === "production" ? "http://192.168.2.162:5000/" : "https://api.apsi.vn:5003/",

   //stream.tvsi.com.vn
   // WSHostAddress: env === "production" ? ("https:" == window.location.protocol ? "wss://" : "ws://") + "localhost:5000" + "/ws" : ("https:" == window.location.protocol ? "wss://" : "ws://") + "localhost:5000" + "/ws",
   // ApiTVSIAddress: env === "production" ? window.location.protocol + "//" + "localhost:5000/" : "http://localhost:5000/",

   WSHostAddress:
      env === "production"
         ? ("https:" == window.location.protocol ? "wss://" : "wss://") + "stream.tvsi.com.vn:5000" + "/ws"
         : ("https:" == window.location.protocol ? "wss://" : "wss://") + "stream.tvsi.com.vn:5000" + "/ws",
   ApiTVSIAddress: "https://stream.tvsi.com.vn:5000/",

   //test noi bo
   // WSHostAddress: env === "production" ? "ws://192.168.2.206:5000/ws" : "ws://192.168.2.206:5000/ws",
   // ApiTVSIAddress: env === "production" ? "http://192.168.2.206:5000/" : "http://192.168.2.206:5000/",

   // test public ban nôi bộ
   // WSHostAddress: env === "production" ? "wss://tvsidata.navisoft.com.vn/ws" : "wss://tvsidata.navisoft.com.vn/ws",
   // ApiTVSIAddress: env === "production" ? "https://tvsidata.navisoft.com.vn/" : "https://tvsidata.navisoft.com.vn/",
};

export const AuthConfig = {
   Yes: "1", //đăng nhập
   No: "2",
};

export const TVSIPriceBoardHasAuth = AuthConfig.Yes; //1: Có đăng nhập, 2: Không đăng nhập

export const constMarketCode = {
   HSX: "STO",
   HNX: "STX",
   UpCOM: "UPX",
   Bond: "HCX",
   Derivative: "DVX",
   TPRL: "TPRL",
};

export const constUrlPathMenu = {
   TopTang: "/banggia/top-incr-prc",
   TopTang_HSX: "/banggia/top-incr-prc/hsx",
   TopTang_HNX: "/banggia/top-incr-prc/hnx",
   TopTang_UpCOM: "/banggia/top-incr-prc/upcom",
   TopGiam: "/banggia/top-decr-prc",
   TopGiam_HSX: "/banggia/top-decr-prc/hsx",
   TopGiam_HNX: "/banggia/top-decr-prc/hnx",
   TopGiam_UpCOM: "/banggia/top-decr-prc/upcom",
   TopKL: "/banggia/top-vol",
   TopKL_HSX: "/banggia/top-vol/hsx",
   TopKL_HNX: "/banggia/top-vol/hnx",
   TopKL_UpCOM: "/banggia/top-vol/upcom",
   TopNNMua: "/banggia/top-fbuy",
   TopNNMua_HSX: "/banggia/top-fbuy/hsx",
   TopNNMua_HNX: "/banggia/top-fbuy/hnx",
   TopNNMua_UpCOM: "/banggia/top-fbuy/upcom",
   TopNNBan: "/banggia/top-fsell",
   TopNNBan_HSX: "/banggia/top-fsell/hsx",
   TopNNBan_HNX: "/banggia/top-fsell/hnx",
   TopNNBan_UpCOM: "/banggia/top-fsell/upcom",
   ThoaThuan: "/banggia/thoathuan/all",
   ThoaThuan_HSX: "/banggia/thoathuan/hsx",
   ThoaThuan_HNX: "/banggia/thoathuan/hnx",
   ThoaThuan_UpCOM: "/banggia/thoathuan/upcom",
   //
   PS_VN30: "/banggia/phaisinh/vn30",
   PS_TPCP: "banggia/phaisinh/tpcp",
};

export const constTabName = {
   Hottrend: "HOT",
   ChungQuyen: "CW",
   TopTang: "TOP_INCR_PRC",
   TopTang_HSX: "TOP_INCR_PRC_HSX",
   TopTang_HNX: "TOP_INCR_PRC_HNX",
   TopTang_UpCOM: "TOP_INCR_PRC_UPCOM",
   TopGiam: "TOP_DECR_PRC",
   TopGiam_HSX: "TOP_DECR_PRC_HSX",
   TopGiam_HNX: "TOP_DECR_PRC_HNX",
   TopGiam_UpCOM: "TOP_DECR_PRC_UPCOM",
   TopKL: "TOP_VOL",
   TopKL_HSX: "TOP_VOL_HSX",
   TopKL_HNX: "TOP_VOL_HNX",
   TopKL_UpCOM: "TOP_VOL_UPCOM",
   TopNNMua: "TOP_FBUY",
   TopNNMua_HSX: "TOP_FBUY_HSX",
   TopNNMua_HNX: "TOP_FBUY_HNX",
   TopNNMua_UpCOM: "TOP_FBUY_UPCOM",
   TopNNBan: "TOP_FSELL",
   TopNNBan_HSX: "TOP_FSELL_HSX",
   TopNNBan_HNX: "TOP_FSELL_HNX",
   TopNNBan_UpCOM: "TOP_FSELL_UPCOM",
   ThoaThuan: "PUTTHROUGH",
   ThoaThuan_HSX: "PUTTHROUGH_HSX",
   ThoaThuan_HNX: "PUTTHROUGH_HNX",
   ThoaThuan_UpCOM: "PUTTHROUGH_UPCOM",
   Nganh: "INDUSTRY",
   Fav: "FAV",
   PS_VN30: "PS_VN30",
   PS_TPCP: "PS_TPCP",
   TPRL: "TPRL",
   EXPAND: "EXPAND",
   TongHop: "TONGHOP",
};

export const constTypeIndex = {
   Market: "0",
   Board: "1",
   Composit: "2",
   Industry: "3",
   Top: "4",
   TRI: "5",
   DPI: "6",
   Scale: "8",
   Invest: "9",
   Group: "G",
};

export const useGlobalConst = () => {
   const { t } = useTranslation();
   return {
      APP: {
         UP: "UP",
         DOWN: "DOWN",
         IN_INPUT: "IN_INPUT",
      },
      ANT: {
         LOCALE: {
            dateFormat: "DD/MM/YYYY",
            dateTimeFormat: "M/D/YYYY h:mm:ss A",
            dateFormats: "DD/MM/YYYY hh:mm:ss",
            dateAll: "DD/MM/YYYY - HH:mm:ss",
            dateTimes: "HH:mm:ss",
            dateFormatDaysT: "YYYY-MM-DDTHH:mm:ss",
         },
         FORM: {
            RULES: {
               chiNhapEmail: {
                  type: "email",
                  message: t("khongDungDinhDangEmail"),
               },
               khongCoBatKyKhoangTrangNao: ({ getFieldValue }) => ({
                  validator(_, value) {
                     if (value && value?.trim().indexOf(" ") >= 0) {
                        return Promise.reject(new Error(t("khongCoKhoangTrangNao")));
                     }
                     return Promise.resolve();
                  },
               }),
               khongNhapKyTuDacBietVaKhoangTrang: ({ getFieldValue }) => ({
                  validator(_, value) {
                     const regex = /^[^\s!@#$%^&*()_+{}[\]:;<>,.?~\\/-]+$/;

                     if (!regex.test(value)) {
                        return Promise.reject(new Error(t("khongDuocNhapKyTuDacBietVaKhoangTrang")));
                     }

                     return Promise.resolve();
                  },
               }),
               gioiHanSoKyTu: (number) => ({
                  pattern: new RegExp(`^[\\w\\W]{${1},${number}}$`),
                  message: `${t("gioiHan")} ${number} ${t("kyTu")}`,
               }),
               yeuCauNhap: {
                  required: true,
                  message: t("khongDuocDeTrong"),
               },
               giaTriKhongDuocDeTrong: (title) => ({
                  validator(_, value) {
                     if (!value || value === "") {
                        return Promise.reject(new Error(`${title} ${t("khongDuocDeTrong2")}`));
                     }
                     return Promise.resolve();
                  },
               }),
               khongDeTrongVaKhacKhong: (title) => ({
                  validator(_, value) {
                     //&& value !== 0
                     if (Number(value) === 0 && value !== undefined && value !== null && value !== "") {
                        return Promise.reject(new Error(`${title} ${t("phaiKhac0")}.`));
                     } else if (!value || value === "") {
                        return Promise.reject(new Error(`${title} ${t("khongDuocDeTrong2")}.`));
                     }
                     return Promise.resolve();
                  },
               }),
               doDaiToiThieu: (title, index) => ({
                  validator(_, value) {
                     //&& value !== 0
                     if (value && value !== "" && value?.length < index) {
                        return Promise.reject(new Error(`${title} ${`${t("phaiLonHonHoacBang2")} ${index} ${t("kyTu")}`}.`));
                     }
                     return Promise.resolve();
                  },
               }),
               chiNhapSo: () => ({
                  validator(_, value) {
                     if (value && !/^[0-9]+$/.test(value) === true) {
                        return Promise.reject(new Error(t("chiNhapSo")));
                     }
                     return Promise.resolve();
                  },
               }),
               gioiHan: (number, min = 0) => ({
                  pattern: new RegExp(`^[\\w\\W]{${min},${number}}$`),
                  message: `${t("vuiLongNhapTu")} ${min} ${t("den")} ${number} ${t("kyTu")}`,
               }),
               ngayNhoHonSoSanh: (dateInput, title1, title2) => {
                  return ({ getFieldsValue }) => ({
                     validator(_, value) {
                        var date = getFieldsValue()[dateInput];
                        const date1 = moment(value, "DD/MM/YYYY");
                        const date2 = moment(date, "DD/MM/YYYY");
                        if (value && date && date1 > date2) {
                           if (!(value + "")?.includes("00010101") && value + "" != "0") {
                              return Promise.reject(new Error(`${title1} ${t("phaiNhoHonHoacBang")} ${title2}`));
                           }
                        }
                        return Promise.resolve();
                     },
                  });
               },
               ngayLonHonSoSanh: (dateInput, title1, title2) => {
                  return ({ getFieldsValue }) => ({
                     validator(_, value) {
                        var date = getFieldsValue()[dateInput];
                        const date1 = moment(value, "DD/MM/YYYY");
                        const date2 = moment(date, "DD/MM/YYYY");
                        if (value && date && date1 < date2) {
                           if (!(value + "")?.includes("00010101") && value + "" != "0") {
                              return Promise.reject(new Error(`${title1} ${t("phaiLonHonHoacBang")} ${title2}`));
                           }
                        }
                        return Promise.resolve();
                     },
                  });
               },
               nhapSoLonHon: (keyName, title1 = "", title2 = "") => {
                  return ({ getFieldsValue }) => ({
                     validator(_, value) {
                        var value2 = getFieldsValue()[keyName];
                        if (value && value !== "" && !isNaN(value) && value2 && value2 !== "" && !isNaN(value2)) {
                           if (Number(value) <= Number(value2)) return Promise.reject(new Error(`${title1} ${t("phaiLonHon")} ${title2}`));
                        }
                        return Promise.resolve();
                     },
                  });
               },
               nhapSoNhoHon: (keyName, title1 = "", title2 = "") => {
                  return ({ getFieldsValue }) => ({
                     validator(_, value) {
                        var value2 = getFieldsValue()[keyName];
                        if (value && value !== "" && !isNaN(value) && value2 && value2 !== "" && !isNaN(value2)) {
                           if (Number(value) >= Number(value2)) return Promise.reject(new Error(`${title1} ${t("phaiNhoHon")} ${title2}`));
                        }
                        return Promise.resolve();
                     },
                  });
               },
               nhapSoNhoHonHoacBang: (keyName, title1 = "", title2 = "") => {
                  return ({ getFieldsValue }) => ({
                     validator(_, value) {
                        var value2 = getFieldsValue()[keyName];
                        if (value && value !== "" && !isNaN(value) && value2 && value2 !== "" && !isNaN(value2)) {
                           if (Number(value) > Number(value2)) return Promise.reject(new Error(`${t("phaiNhoHonHoacBang")} ${title2}`));
                        }
                        return Promise.resolve();
                     },
                  });
               },
               chuaChuHoaChuThuongVaSo: () => ({
                  validator(_, value) {
                     const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;

                     if (!regex.test(value)) {
                        return Promise.reject(new Error(t("yeuCauChuaItNhatMotChuHoa")));
                     }

                     return Promise.resolve();
                  },
               }),
               checkValidateNewPassword: () => ({
                  validator(_, value) {
                     const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
                     const regexSpecial = /^(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]).*$/;

                     if (value || value === "") {
                        if (value.length < 8 || value.length > 32) {
                           return Promise.reject(new Error(t("doDaiPhaiTu832KyTu")));
                        } else if (value.indexOf(" ") >= 0) {
                           return Promise.reject(new Error(t("khongBaoGomKhoangTrang")));
                        } else if (!regexSpecial.test(value) || !regex.test(value)) {
                           return Promise.reject(new Error(t("matKhauPhaiBaoGom")));
                        }
                     }

                     return Promise.resolve();
                  },
               }),
            },
            ITEM: {
               PARSER: {},
               INPUT: {
                  SELECT_COMPLEX_SEARCH: {
                     showSearch: true,
                     getPopupContainer: (trigger) => trigger.parentElement,
                     onDropdownVisibleChange: (visible) => {},
                     onInputKeyDown: (e) => {},
                     filterOption: (input, option) => {
                        let str = "";
                        if (option.plainText && typeof option.plainText === "string") {
                           str = option.plainText?.toLowerCase();
                        } else if (Array.isArray(option.children)) {
                           str = option.children
                              .filter((e) => typeof e === "string")
                              .join("")
                              .toLowerCase();
                        } else {
                           if (option.children && typeof option.children === "string") {
                              str = option.children.toLowerCase();
                           } else {
                              if (typeof option.label === "string") {
                                 str = option.label?.toLowerCase();
                              } else {
                                 str = "";
                              }
                           }
                        }
                        var regex = /\d+/g;
                        if (input.match(regex) && input.match(regex)[0] !== "") {
                           return (str ?? "").toLowerCase().includes(input.toLowerCase());
                        }
                        return (str ?? "").toLowerCase().includes(input.toLowerCase());
                     },
                  },
               },
            },
         },
      },
      MODULE: {},
      ITEM: {
         INPUT: {
            SELECT_COMPLEX_SEARCH: {
               placeholder: t("luaChon"),
               showSearch: true,
               getPopupContainer: (trigger) => trigger.parentElement,
               onDropdownVisibleChange: (visible) => {},
               onBlur: (e) => {},
               onFocus: (e) => {},
               onInputKeyDown: (e) => {},
               filterOption: (input, option) => {
                  let str = "";
                  if (option.plainText && typeof option.plainText === "string") {
                     str = option.plainText?.toLowerCase();
                  } else if (Array.isArray(option.children)) {
                     str = option.children
                        .filter((e) => typeof e === "string")
                        .join("")
                        .toLowerCase();
                  } else {
                     if (option.children && typeof option.children === "string") {
                        str = option.children.toLowerCase();
                     } else {
                        if (typeof option.label === "string") {
                           str = option.label?.toLowerCase();
                        } else {
                           str = "";
                        }
                     }
                  }
                  var regex = /\d+/g;
                  if (input.match(regex) && input.match(regex)[0] !== "") {
                     return (str ?? "").toLowerCase().includes(input.toLowerCase());
                  }
                  return (str ?? "").toLowerCase().includes(input.toLowerCase());
               },
            },
            SELECT_KEY: {
               placeholder: t("luaChon"),
               showSearch: true,
               getPopupContainer: (trigger) => trigger.parentElement,
               onDropdownVisibleChange: (visible) => {},
               onBlur: (e) => {},
               onFocus: (e) => {},
               onInputKeyDown: (e) => {},
               filterOption: (input, option) => {
                  return option?.value.toUpperCase().startsWith(input.toUpperCase());
               },
            },
         },
      },
   };
};

export const DateFormat = {
   YYYYMMDD: "YYYYMMDD",
};
